/** A score with a fixed number of decimals, and a dash where there is no number. */
export function formatScore(value: number, decimals = 2): string {
  return Number.isFinite(value) ? value.toFixed(decimals) : '—';
}

/** How long ago the user last used the skill, in words. Null means never. */
export function formatDaysSince(days: number | null): string {
  if (days === null) return 'never';
  if (days < 1) return 'today';
  if (days < 2) return '1 day ago';
  return `${Math.floor(days)} days ago`;
}
